export default __webpack_public_path__ + "static/media/star-of-the-city.5e0aba27.png";